const getPricePerPoint = (userPointPrice: number, points: number) => {
  if (points === 0) {
    return 0.0
  }
  if (userPointPrice === 66) {
    return points < 100
      ? 0.66
      : points < 200
      ? 0.59
      : points < 350
      ? 0.49
      : 0.43
  }
  return userPointPrice * 0.01
}

export default getPricePerPoint
